import req from './request.js'

export function videoList(data) {
  return req('get', '/api/video/lists', data)
}

export function videoInfo(data) {
  return req('get', '/api/video/videoInfo', data)
}


export function historyView(data) {
  return req('get', '/api/video/historyView', data)
}
